const API_BASE_URL = process.env.BASE_URL

export const USER_ENDPOINT = API_BASE_URL + "/user/me/"
